

import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'TPV'

export const TPVEP : EndPointConfig[] =[
        
        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("GetPCIProxyTransactionIdByAliasToken"),

          
]